export const mediaFormats = {
    pls: 'pls',
    tipls: 'tipls',
    hls: 'hls',
};
export const hlsMediaFormatMap = {
    m3u: mediaFormats.hls,
    m3u8: mediaFormats.hls,
};
